module.exports = __webpack_public_path__ + "media/images/tl/banner/zh-hant-light-pc-2bede88a13d13b3601bcf9c0e4644b50.jpg";